import React from 'react';

export function PanelExpand({ fill = '#99A2B8' }: { fill?: string }) {
  return (
    <svg
      width="24px"
      height="15px"
      viewBox="0 0 24 15"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g
        className="panel-expand-icon"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          className="panel-expand-content"
          fill={fill}
          transform="translate(-0, 0)"
        >
          <rect className="top-line" x="13" y="0" width="11" height="3"></rect>
          <rect
            className="middle-line"
            x="9"
            y="6"
            width="15"
            height="3"
          ></rect>
          <rect
            className="bottom-line"
            x="9"
            y="12"
            width="15"
            height="3"
          ></rect>
          <polygon
            className="expand-arrow"
            transform="translate(2.5, 7.5) rotate(-90) translate(-2.5, -7.5)"
            points="2.5 5 7.16666667 10 -2.16666667 10"
          ></polygon>
        </g>
      </g>
    </svg>
  );
}

export function PanelRetract({ fill = '#000000' }: { fill?: string }) {
  return (
    <svg
      width="24px"
      height="15px"
      viewBox="0 0 24 15"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g
        className="panel-retract-icon"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <rect
          className="top-line"
          fill={fill}
          x="13"
          y="0"
          width="11"
          height="3"
        ></rect>
        <rect
          className="middle-line"
          fill={fill}
          x="9"
          y="6"
          width="15"
          height="3"
        ></rect>
        <rect
          className="bottom-line"
          fill={fill}
          x="9"
          y="12"
          width="15"
          height="3"
        ></rect>
        <polygon
          className="retract-arrow"
          fill={fill}
          transform="translate(2.5, 7.5) scale(-1, 1) rotate(-90) translate(-2.5, -7.5)"
          points="2.5 5 7.16666667 10 -2.16666667 10"
        ></polygon>
      </g>
    </svg>
  );
}
